var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('router-link',{staticClass:"btn dealers_btn mr-3",staticStyle:{"font-size":"15px"},attrs:{"to":{
      name: 'dealer_branc_expense_breakdown',
      query: {
        branchName: _vm.data.name,
        category: _vm.$route.query.category,
        branchId: _vm.data.id,
        dealerId: _vm.$route.query.dealerId,
      },
    }}},[_vm._v("\n    View breakdown "+_vm._s(_vm.$t('text.clickButtons.viewBreakDown'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }